import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr.json';
import en from './locales/en.json';
import de from './locales/de.json';
import es from './locales/es.json';
import it from './locales/it.json';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      fr: { translation: fr },
      en: { translation: en },
      de: { translation: de },
      es: { translation: es },
      it: { translation: it }
    },
    // Détection automatique de la langue du navigateur / système avec fallback en 'en'
    lng: (() => {
      try {
        const supported = ['fr','en','de','es','it'];
        // Respecter le choix utilisateur s'il a déjà été fixé
        const stored = typeof window !== 'undefined' ? window.localStorage.getItem('i18nextLng') : null;
        if (stored) {
          // i18next stocke parfois des codes complets (ex: en-US), on normalise
          const base = stored.split('-')[0].toLowerCase();
          return supported.includes(base) ? base : 'en';
        }
        const navLangs = typeof navigator !== 'undefined' ? (navigator.languages || [navigator.language || navigator.userLanguage]).filter(Boolean) : [];
        for (const lang of navLangs) {
          const base = lang.split('-')[0].toLowerCase();
          if (supported.includes(base)) return base;
        }
        return 'en';
      } catch {
        return 'en';
      }
    })(),
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false // React échappe déjà le HTML
    }
  });

export default i18n;
